import { BankError } from '#modules/Bank/Bank.types'
import { BankLoginAction } from '../../actions/consumerDataPullSessionActions/bankLoginActions'

export enum BankLoginProcessStatus {
	IDLE_STATUS = 'idle',
	LOADING_STATUS = 'loading',
	FAILURE_STATUS = 'failure',
	SUCCESS_STATUS = 'success',
}
export interface BankLoginState {
	monthioInternalBankId: number | null
	creatingBankUrl: boolean
	authUrl: string | null
	usePopup: boolean
	usePsd2Consent: boolean
	createBankLoginError: BankError | null
	status: BankLoginProcessStatus
}

export const INITIAL_STATE = {
	monthioInternalBankId: null,
	creatingBankUrl: false,
	authUrl: null,
	usePopup: false,
	usePsd2Consent: false,
	createBankLoginError: null,
	status: BankLoginProcessStatus.IDLE_STATUS,
}

export default function reduce(
	state: BankLoginState = INITIAL_STATE,
	action: BankLoginAction,
): BankLoginState {
	switch (action.type) {
		case 'CREATE_BANK_LOGIN_URL':
			return {
				...state,
				creatingBankUrl: true,
				authUrl: null,
				monthioInternalBankId: action.bankId!,
				status: BankLoginProcessStatus.LOADING_STATUS,
			}
		case 'CREATE_BANK_LOGIN_URL_SUCCEEDED':
			return {
				...state,
				...action.bankLoginUrlDto,
				creatingBankUrl: false,
				usePsd2Consent: action.bankLoginUrlDto.usePsd2Consent,
				status: BankLoginProcessStatus.SUCCESS_STATUS,
			}
		case 'CREATE_BANK_LOGIN_URL_FAILED':
			return {
				...state,
				createBankLoginError: action.createBankLoginError,
				creatingBankUrl: false,
				monthioInternalBankId: null,
				status: BankLoginProcessStatus.FAILURE_STATUS,
			}
		case 'BANK_LOGIN_CLEAR_ERRORS':
			return {
				...state,
				status: BankLoginProcessStatus.IDLE_STATUS,
				createBankLoginError: null,
			}
		case 'BANK_LOGIN_CLEAR_STATE':
			return { ...INITIAL_STATE }
		default:
			return state
	}
}
